import { AccordionSummary, Accordion, AccordionDetails, Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { useState } from "react";
import { GenericTable } from "../../../components/GenericTable/GenericTable";
import { ConsentActions } from "./ConsentActions";
import { ConsentMobileList } from "./ConsentMobileList";
import { getConsentTableColumns } from "./consentTableColumns";
import dayjs from "dayjs";

interface IConsentAccordion {
  defaultOpen?: boolean;
  title: string;
  type: string;
  selectedTab: string;
  data: any;
}

export function translateStatus(status: string) {
  switch (status) {
    case "expired":
      return "Expirado";
    case "valid":
      return "Válido";
    case "revoked":
      return "Revogado";
    default:
      return "";
  }
}

export function ConsentAccordion({
  defaultOpen,
  title,
  type,
  data,
  selectedTab,
}: IConsentAccordion) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));
  const [openAccordion, setOpenAccordion] = useState<boolean>(
    defaultOpen || false
  );

  const sortedData = Array.isArray(data)
    ? [...data].sort((a: any, b: any) => {
        const dateA = dayjs(a?.fullDate);
        const dateB = dayjs(b?.fullDate);
        return dateB.diff(dateA);
      })
    : data;

  if (Array.isArray(sortedData) && sortedData.length > 0) {
    const updatedData = sortedData.map((item) => ({
      ...item,
      status: translateStatus(item?.status),
    }));

    data = updatedData;
  }

  const columns = getConsentTableColumns(selectedTab, type);

  if (isMobileLayout) {
    if (!Array.isArray(data) || data.length === 0) return null;

    return (
      <Box sx={{ mb: 2.5 }}>
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.25 }}>
          {title}
        </Typography>
        <ConsentMobileList
          sectionTitle={title}
          data={data}
          type={type}
          selectedTab={selectedTab}
        />
      </Box>
    );
  }

  return (
    <Accordion
      sx={{ width: "100%" }}
      expanded={openAccordion}
      onChange={() => setOpenAccordion((prev: boolean) => !prev)}
    >
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        {title}
      </AccordionSummary>

      <AccordionDetails>
        <GenericTable
          tableColumns={columns}
          tableRows={data?.sort((a: any, b: any) => {
            const dateA = dayjs(a?.fullDate);
            const dateB = dayjs(b?.fullDate);
            return dateB.diff(dateA);
          })}
          actions={(rowData: any) => (
            <ConsentActions row={rowData} type={type} />
          )}
        />
      </AccordionDetails>
    </Accordion>
  );
}
